<script>
  export let id;
  export let label = "";
  export let required = false;
</script>

<label for={id} class="mb-2 block text-sm font-bold text-gray-700">
  <slot />
  {label}
  {#if required}<span class="text-red-700">*</span>{/if}
</label>
